<template>
    <div v-if="!appData.enableSamlTrial && !appData.enableSamlOption">
        <div class="object-titlebox">
            <div class="object-titlebox-left" v-t="'message.item_saml_setting'"></div>
        </div>
        <div class="object-inner-table">
            <table width=100%>
                <td v-if="appData.basicContract.planType == Const.LICENSE_PLAN_SEPARATE" width=50% class="object-item" v-t="'message.info_need_purchase_option'">
                </td>
                <td v-else width=50% class="object-item" v-t="'message.info_need_purchase_enterprise_plan'">
                </td>
            </table>
        </div>
    </div>
    <div v-else>
        <div class="object-titlebox">
            <div class="object-titlebox-left" v-t="'message.item_saml_setting'"></div>
            <div class="object-titlebox-right">
                <span v-if="enableSamlAuth">
                    <button class="transparent-button" type="button" v-on:click="showEditSamlSettingDialog"><img src="../../../../assets/edit.svg"/><span class="normal-command-text" v-t="'message.common_action_edit'"></span></button>
                    <button class="transparent-button" type="button" v-on:click="showDisableSamlSetting=true"><img src="../../../../assets/delete.svg"/><span class="important-command-text" v-t="'message.common_action_delete'"></span></button>
                </span>
                <span v-else>
                    <button class="transparent-button" type="button" v-on:click="showEditSamlSettingDialog"><img src="../../../../assets/add_user.svg"/><span class="normal-command-text" v-t="'message.common_action_add'"></span></button>
                </span>
            </div>
        </div>
        <table v-if="enableSamlAuth" width="100%">
            <tr style="background-color: #f6f6f6">
                <td class="object-title" width="50%" style="color:#848991;padding-left:20px" v-t="'message.item_setting_name'"></td>
                <td class="object-title" width="50%"style="color:#848991" v-t="'message.item_setting_value'"></td>
            </tr>
            <tr>
                <td class="object-value" width="50%" style="padding-left:20px" v-t="'message.item_saml_layer'"></td>
                <td class="object-value" width="50%">{{ samlAuthInfo.defaultLayer }}</td>
            </tr>
            <tr>
                <td class="object-value" width="50%" style="padding-left:20px" v-t="'message.item_saml_group'"></td>
                <td class="object-value" width="50%">{{ samlAuthInfo.defaultGroup }}</td>
            </tr>
            <tr>
                <td class="object-value" width="50%" style="padding-left:20px" v-t="'message.item_idp_metadata'"></td>
                <td v-if="samlAuthInfo.metaDataUpload" class="object-value" width="50%" v-t="'message.info_uploaded'"></td>
            </tr>
            <tr>
                <td class="object-value" width="50%" style="padding-left:20px" v-t="'message.item_saml_enable_autoextend_license'"></td>
                <td class="object-value" width="50%">{{ getLicenseAutoExtendText() }}</td>
            </tr>
            <tr style="background-color: #f6f6f6">
                <td class="object-title" colspan="2" style="color:#848991;padding-left:20px" v-t="'message.info_idp_mapping'"></td>
            </tr>
            <tr style="background-color: #f6f6f6">
                <td class="object-title" width="50%" style="color:#848991;padding-left:20px" v-t="'message.title_user_information'"></td>
                <td class="object-title" width="50%" style="color:#848991" v-t="'message.item_user_attribute_name'"></td>
            </tr>
            <tr>
                <td class="object-value" width="50%" style="padding-left:20px" v-t="'message.item_userDisplayName'"></td>
                <td class="object-value" width="50%">{{ samlAuthInfo.displayName }}</td>
            </tr>
            <tr>
                <td class="object-value" width="50%" style="padding-left:20px" v-t="'message.item_tenant_department'"></td>
                <td class="object-value" width="50%">{{ samlAuthInfo.departmentName }}</td>
            </tr>
            <tr>
                <td class="object-value" width="50%" style="padding-left:20px" v-t="'message.item_job_title'"></td>
                <td class="object-value" width="50%">{{ samlAuthInfo.jobTitle }}</td>
            </tr>
            <tr>
                <td class="object-value" width="50%" style="padding-left:20px" v-t="'message.item_tenant_phone'"></td>
                <td class="object-value" width="50%">{{ samlAuthInfo.phoneNumber }}</td>
            </tr>
        </table>
        <table v-else>
            <tr>
                <td class="object-item" v-t="'message.info_need_to_add_saml_setting'"></td>
            </tr>
        </table>
        <EditSamlSetting v-if="showEditSamlSetting" :appData="appData" :inputForm="editSettingForm" :editType="settingEditType" :currentMax="currentMax" @save="setSamlSetting" @cancel="closeEditSamlSettingDialog" @showDialog="showObjectSelectionDialog"></EditSamlSetting>
        <ConfirmGeneral v-if="showDisableSamlSetting" :confirmInfo="generalConfirmInfo" @agree="disableSamlAuthentication" @cancel="closeDisableSamlSettingDialog"></ConfirmGeneral>
        <ObjectSelection v-if="showObjectSelection" :appData="appData" :objectType="selectionObjectType" :showAdminUser="false" @close="closeObjectSelectionDialog"></ObjectSelection>
    </div>
</template>

<script>
import server from "../../../ServerApi.js";
import commonUtil from '../../../commonutil.js';
import constants from '../../../constants.js';
import EditSamlSetting from "./EditSamlSetting.vue";
import ConfirmGeneral from "../../../ConfirmGeneral.vue";
import ObjectSelection from "../../../ObjectSelection.vue"

export default {
    data() {
        return {
            currentMax: null,
            showEditSamlSetting: false,
            showDisableSamlSetting: false,
            enableSamlAuth: false,
            selectionObjectType: 0,
            settingEditType: null,
            samlAuthInfo: {
                metaDataUpload: false,
                defaultGroup: null,
                defaultLayer: null,
                displayName: null,
                departmentName: null,
                jobTitle: null,
                autoExtendLicenseLimit: null
            },
            editSettingForm: {
                groupName:          { validationRule: "none",       valid: false, value: null },
                layerName:          { validationRule: "none",       valid: false, value: null },
                displayName:        { validationRule: "none",       valid: false, value: null,   isComposing: false },
                departmentName:     { validationRule: "none",       valid: false, value: null,   isComposing: false },
                jobTitle:           { validationRule: "none",       valid: false, value: null,   isComposing: false },
                phoneNumber:        { validationRule: "none",       valid: false, value: null,   isComposing: false },
                idpMetaData:        { validationRule: "none",       valid: false, value: null,   isComposing: false, uploadFile: null },
                maxLicenseCount:    { validationRule: "none",       valid: true,  value: null },
                autoExtendLicense:  { validationRule: "none",       valid: true,  value: null },
                unlimitedLicense:   { validationRule: "none",       valid: true,  value: null },
            },
            generalConfirmInfo:{
                title: null,
                description: null
            },
            Const: {
                LICENSE_PLAN_SEPARATE: constants.LICENSE_PLAN_SEPARATE
            }
        };
    },
    methods: {
        setSettingInfo() {
            this.enableSamlAuth = this.appData.tenantList[0].samlLayer != null ? true : false;
            if (this.enableSamlAuth) {
                this.getSamlLayerInfo();
                this.getSamlGroupInfo();
                this.samlAuthInfo.metaDataUpload = this.appData.tenantList[0].idpMetaData;
                this.samlAuthInfo.autoExtendLicenseLimit = this.appData.tenantList[0].autoExtendLicenseLimit;
                if ((typeof this.appData.tenantList[0].samlAttributeFormula === "undefined") ||
                    (this.appData.tenantList[0].samlAttributeFormula == null)) {
                    this.samlAuthInfo.displayName = this.editSettingForm.displayName.value = null;
                    this.samlAuthInfo.departmentName = this.editSettingForm.departmentName.value = null;
                    this.samlAuthInfo.jobTitle = this.editSettingForm.jobTitle.value = null;
                    this.samlAuthInfo.phoneNumber = this.editSettingForm.phoneNumber.value = null;
                } else {
                    let samlAttributeFormula = JSON.parse(this.appData.tenantList[0].samlAttributeFormula);
                    this.samlAuthInfo.displayName = this.editSettingForm.displayName.value = samlAttributeFormula.displayName;
                    this.samlAuthInfo.departmentName = this.editSettingForm.departmentName.value = samlAttributeFormula.departmentName;
                    this.samlAuthInfo.jobTitle = this.editSettingForm.jobTitle.value = samlAttributeFormula.jobTitle;
                    this.samlAuthInfo.phoneNumber = this.editSettingForm.phoneNumber.value = samlAttributeFormula.phoneNumber;
                }
            } else {
                for (let formItem in this.editSettingForm) {
                    switch(formItem) {
                        case "idpMetaData":
                            this.editSettingForm[formItem].uploadFile = null;
                            this.editSettingForm[formItem].valid = false;
                            break;
                        case "maxLicenseCount":
                        case "autoExtendLicense":
                        case "unlimitedLicense":
                            break;
                        default:
                            this.editSettingForm[formItem].value = null;
                            this.editSettingForm[formItem].valid = false;
                            break;
                    }
                }
            }
            this.setAutoExtendInfo();
            this.setCurrentMaxInfo();
        },
        setAutoExtendInfo() {
            this.editSettingForm.maxLicenseCount.value = this.samlAuthInfo.autoExtendLicenseLimit;
            if (this.samlAuthInfo.autoExtendLicenseLimit == 0) {
                this.editSettingForm.autoExtendLicense.value = false;
                this.editSettingForm.unlimitedLicense.value = false;
            } else {
                this.editSettingForm.autoExtendLicense.value = true;
                if (this.samlAuthInfo.autoExtendLicenseLimit == -1) {
                    this.editSettingForm.unlimitedLicense.value = true;
                } else {
                    this.editSettingForm.unlimitedLicense.value = false;
                }
            }
        },
        setCurrentMaxInfo() {
            if (this.appData.basicContract.purchasePeriodType == constants.PURCHASE_PERIOD_MONTHLY) {
                let numberLicense = this.appData.numberContract.filter(function(item, index) {
                    if (item.type == constants.LICENSE_USER) return true;
                });
                this.currentMax = numberLicense[0].currentMax;
            } else {
                this.currentMax = null;
            }
        },
        uploadMetaData() {
            let self = this;
            server.postWithFile("/uploadidpmetadata", this.uploadFile
            ).then((res) => {
                self.uploadFile = null;
                this.appData.tenantList[0].idpMetaData = this.samlAuthInfo.metaDataUpload = true;
                commonUtil.notifyMessage(self,"Success",commonUtil.getMessageText(self.$i18n,"info_idp_metadata_uploaded"));
            })
            .catch( function ( error ) {
                commonUtil.putExceptionErrorMessage(self, "uploadMetaData", error);
            });
        },
        getUserRights() {
            let self = this;
            server.post('/getinfo',{tenantId: this.appData.tenantList[0].tenantId, id: this.appData.loginUserObjectId, userTalkgroupInfo: false }
            ).then((res) => {
                switch (res.data.status) {
                    case constants.STATUS_SUCCESS:
                        self.managementUserRights = commonUtil.checkUserPrivilege(res.data.rights, constants.PRIVILEGE_TENANT_ADMIN);
                        break;
                    case constants.STATUS_ERROR_DENIED:
                    case constants.STATUS_ERROR_OBJECT_NOT_FOUND:
                        commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_cannot_confirm_link_user"));
                        break;
                    default:
                        commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_server_api").replace("{functionName}","getUserRights").replace("{code}",res.data.status));
                        break;
                }
            })
            .catch( function ( error ) {
                commonUtil.putExceptionErrorMessage(self, "getUserRights", error);
            });
        },
        getSamlLayerInfo() {
            let self = this;
            server.post('/getinfo',{tenantId: this.appData.tenantList[0].tenantId, id: this.appData.tenantList[0].samlLayer }
            ).then((res) => {
                switch (res.data.status) {
                    case constants.STATUS_SUCCESS:
                        self.samlAuthInfo.defaultLayer = self.editSettingForm.layerName.value = res.data.name;
                        break;
                    default:
                        commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_server_api").replace("{functionName}","getSamlLayerInfo").replace("{code}",res.data.status));
                        break;
                }
            })
            .catch( function ( error ) {
                commonUtil.putExceptionErrorMessage(self, "getSamlLayerInfo", error);
            });
        },
        getSamlGroupInfo() {
            let self = this;
            server.post('/getinfo',{tenantId: this.appData.tenantList[0].tenantId, id: this.appData.tenantList[0].samlGroup, userTalkgroupInfo: false }
            ).then((res) => {
                switch (res.data.status) {
                    case constants.STATUS_SUCCESS:
                        self.samlAuthInfo.defaultGroup = self.editSettingForm.groupName.value = res.data.name;
                        break;
                    default:
                        commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_server_api").replace("{functionName}","getSamlGroupInfo").replace("{code}",res.data.status));
                        break;
                }
            })
            .catch( function ( error ) {
                commonUtil.putExceptionErrorMessage(self, "getSamlGroupInfo", error);
            });
        },
        showObjectSelectionDialog(objectType, input) {
            if(this.showEditSamlSetting) {
                this.showEditSamlSetting = false;
            }
            if(this.showDisableSamlSetting) {
                this.showDisableSamlSetting = false;
            }
            this.selectionObjectType = objectType
            this.showObjectSelection = true;
        },
        closeObjectSelectionDialog(requestType, selectedObjectName) {
            if (selectedObjectName != null) {
                switch(requestType) {
                    case constants.OBJECT_NODE:
                        this.editSettingForm.layerName.value = selectedObjectName;
                        this.editSettingForm.layerName.valid = true;
                        break;
                    case constants.OBJECT_TALKGROUP:
                        this.editSettingForm.groupName.value = selectedObjectName;
                        this.editSettingForm.groupName.valid = true;
                        break;
                }
            }
            this.showObjectSelection = false;
            this.showEditSamlSetting = true;
        },
        showEditSamlSettingDialog() {
            if (this.enableSamlAuth) {
                this.settingEditType = 1;
                for(var validateItem in this.editSettingForm) {
                    this.editSettingForm[validateItem].valid = true;
                }
            } else {
                this.editSettingForm.displayName.valid = true;
                this.editSettingForm.departmentName.valid = true;
                this.editSettingForm.jobTitle.valid = true;
                this.editSettingForm.phoneNumber.valid = true;
                this.settingEditType = 0;
            }
            this.showEditSamlSetting = true;
        },
        closeEditSamlSettingDialog(input) {
            this.setSettingInfo();
            this.showEditSamlSetting = false;
        },
        setSamlSetting(input) {
            this.showEditSamlSetting = false;
            let idpMappingInfo = {};
            if ((this.editSettingForm.displayName.value != null) ||
                (this.editSettingForm.departmentName.value != null) ||
                (this.editSettingForm.jobTitle.value != null) ||
                (this.editSettingForm.phoneNumber.value != null)) {
                idpMappingInfo.displayName = this.editSettingForm.displayName.value
                idpMappingInfo.departmentName = this.editSettingForm.departmentName.value
                idpMappingInfo.jobTitle = this.editSettingForm.jobTitle.value
                idpMappingInfo.phoneNumber = this.editSettingForm.phoneNumber.value
            } else {
                idpMappingInfo = null;
            }
            let param;
            let commandName;
            if (this.enableSamlAuth) {
                commandName = "/modifytenantsamlinfo";
                param = {
                    newSamlLayer: this.editSettingForm.layerName.value,
                    newSamlGroup: this.editSettingForm.groupName.value,
                };
                if (idpMappingInfo != null) {
                    param.newIdpMappingInfo = idpMappingInfo;
                }
                if (this.editSettingForm.autoExtendLicense.value) {
                    if (this.editSettingForm.unlimitedLicense.value) {
                        param.newMaxExtendLicenseCount = -1;
                    } else {
                        param.newMaxExtendLicenseCount = this.editSettingForm.maxLicenseCount.value
                    }
                } else {
                    param.newMaxExtendLicenseCount = 0
                }
            } else {
                commandName = "/enablesamlauthentication";
                param = {
                    defaultLayerOfUser: this.editSettingForm.layerName.value,
                    defaultGroupOfUser: this.editSettingForm.groupName.value,
                };
                if (idpMappingInfo != null) {
                    param.idpMappingInfo = idpMappingInfo;
                }
                if (this.editSettingForm.autoExtendLicense.value) {
                    if (this.editSettingForm.unlimitedLicense.value) {
                        param.maxExtendLicenseCount = -1;
                    } else {
                        param.maxExtendLicenseCount = this.editSettingForm.maxLicenseCount.value
                    }
                } else {
                    param.maxExtendLicenseCount = 0
                }
            }
            let self = this;
            server.postWithFile(commandName, this.editSettingForm.idpMetaData.uploadFile, JSON.stringify(param)
            ).then((res) => {
                self.editSettingForm.idpMetaData.uploadFile = null;
                switch (res.data.status) {
                    case constants.STATUS_SUCCESS:
                        if (commandName == "/enablesamlauthentication") {
                            commonUtil.notifyMessage(self,"Success",commonUtil.getMessageText(self.$i18n,"info_saml_setting_created"));
                        } else {
                            commonUtil.notifyMessage(self,"Success",commonUtil.getMessageText(self.$i18n,"info_saml_setting_modified"));
                        }
                        self.appData.commonFunc.loadTenantInfo();
                        break;
                    case constants.STATUS_ERROR_OPTION_UNMATCH:
                        commonUtil.notifyMessage(self,"Warning", commonUtil.getMessageText(self.$i18n,"error_cannot_use_as_saml_default").replace("{groupName}",self.editSettingForm.groupName.value));
                        break;
                    default:
                        commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_server_api").replace("{functionName}","closeEditSamlSettingDialog").replace("{code}",res.data.status));
                        break;
                }
            })
            .catch( function ( error ) {
                self.editSettingForm.idpMetaData.uploadFile = null;
                commonUtil.putExceptionErrorMessage(self, "closeEditSamlSettingDialog", error);
            });
        },
        closeDisableSamlSettingDialog() {
            this.setSettingInfo();
            this.showDisableSamlSetting = false;
        },
        disableSamlAuthentication(input) {
            this.closeDisableSamlSettingDialog();
            let self = this;
            server.post("/disablesamlauthentication", {}
            ).then((res) => {
                switch (res.data.status) {
                    case constants.STATUS_SUCCESS:
                        commonUtil.notifyMessage(self,"Success",commonUtil.getMessageText(self.$i18n,"info_saml_setting_deleted"));
                        self.appData.commonFunc.loadTenantInfo();
                        break;
                    default:
                        commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_server_api").replace("{functionName}","getUserRights").replace("{code}",res.data.status));
                        break;
                }
            })
            .catch( function ( error ) {
                commonUtil.putExceptionErrorMessage(self, "closeDisableSamlSettingDialog", error);
            });
        },
        getLicenseAutoExtendText() {
            switch(this.samlAuthInfo.autoExtendLicenseLimit) {
                case -1:
                    return commonUtil.getMessageText(this.$i18n,"item_saml_autoextend_license_infinite");
                case 0:
                    return commonUtil.getMessageText(this.$i18n,"item_saml_not_autoextend_license");
                default:
                    return commonUtil.getMessageText(this.$i18n,"item_saml_autoextend_license").replace('{count}',this.samlAuthInfo.autoExtendLicenseLimit);
            }
        }
    },
    mounted: function() {
    },
    created: function() {
        this.setSettingInfo();
        this.generalConfirmInfo.title = commonUtil.getMessageText(this.$i18n,"title_saml_setting_delete");
        this.generalConfirmInfo.description = commonUtil.getMessageText(this.$i18n,"info_saml_setting_delete");
    },
    watch: {
        'appData.tenantList'(newVal) {
            if (newVal != null) {
                this.setSettingInfo();
            }
        },
        'appData.basicContract'(newVal) {
            if (newVal != null) {
                this.setAutoExtendInfo();
            }
        },
        'appData.numberContract'(newVal) {
            if (newVal != null) {
                this.setCurrentMaxInfo();
            }
        },
        '$route' (to, from) {
        }
    },
    components: {
        EditSamlSetting,
        ConfirmGeneral,
        ObjectSelection
    },
    props: [ 'appData']
}

</script scoped>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.object-value {
    padding: 10px 10px;
}

.object-title {
    padding: 10px 10px;
    font-size: 12px;
}

.icon-help {
    height: 14px;
}

.title-box-right {
    position: relative;
    text-align: right;
    vertical-align: middle;
    font-size: 12px;
    float: right;
}

.title-box-left {
    padding: 10px;
    padding-left: 20px;
    color: #848991;
    font-size: 12px;
    vertical-align: middle;
}

</style>
